import {Component, Input, OnInit} from '@angular/core';
import {IEmployee} from '@signal/asp-data-commons';


@Component({
  selector: 'app-employee-list',
  templateUrl: './employee-list.component.html',
  styleUrls: ['./employee-list.component.scss']
})
export class EmployeeListComponent implements OnInit {
  colNumber: number;
  @Input() employees: IEmployee[];
  constructor() {
  }

  ngOnInit() {
    this.colNumber = (window.innerWidth <= 890) ? 1 : (window.innerWidth <= 1200) ? 2 : (window.innerWidth <= 1520) ? 3 : (window.innerWidth <= 1820) ? 4 : 5;
  }

  onResize(event?: any) {
    this.colNumber = (event.target.innerWidth <= 890) ? 1 : (event.target.innerWidth <= 1200) ? 2 : (event.target.innerWidth <= 1520) ? 3 : (event.target.innerWidth <= 1820) ? 4 : 5;
  }

}
